import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth.jsx'
import { TimerProvider } from './hooks/useTimers.jsx'

import SignIn from './pages/SignIn.jsx'
import OAuthCallback from './pages/OAuthCallback.jsx'
import BookCover from './pages/BookCover.jsx'
import RecipeList from './pages/RecipeList.jsx'
import RecipeDetail from './pages/RecipeDetail.jsx'
import Privacy from './pages/Privacy.jsx'
import DataDeletion from './pages/DataDeletion.jsx'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!user) return <Navigate to="/" replace />
  return children
}

function LoadingScreen() {
  return (
    <div style={{
      height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f2faf6',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 44, height: 44, border: '3px solid #4d8b6f', borderTopColor: 'transparent',
          borderRadius: '50%', animation: 'spin 0.9s linear infinite', margin: '0 auto 16px',
        }} />
        <p style={{ color: '#2d6a4f', fontFamily: "'Inter', sans-serif", fontSize: 16, fontWeight: 500 }}>
          Loading My Cookbook…
        </p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}

function AppRoutes() {
  const { user, loading } = useAuth()

  if (loading) return <LoadingScreen />

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/cover" replace /> : <SignIn />} />
      <Route path="/auth/callback" element={<OAuthCallback />} />
      <Route path="/cover" element={<ProtectedRoute><BookCover /></ProtectedRoute>} />
      <Route path="/recipes" element={<ProtectedRoute><RecipeList /></ProtectedRoute>} />
      <Route path="/recipes/:id" element={<ProtectedRoute><RecipeDetail /></ProtectedRoute>} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TimerProvider>
          <AppRoutes />
        </TimerProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
